<template>
  <a-layout  class="layout">
    <side-menu
      style="position:relative"
      mode="inline"
      :menus="menus"
      :theme="theme"
      :collapsed="collapsed"
      :collapsible="true"
      @select="onSelect"/>
    <a-layout
      :class="['side-menu', `content-width-${contentWidth}`]"
      style="min-height:100vh;overflow:hidden">
      <global-header
        :collapsed="collapsed"
        @toggle="toggle"/>
        <a-layout-content :style="{  margin: '12px 12px 0', padding:'32px,0px,0px'}">
          <div class="header-tips clearfix">
            <multi-tab @afterClose='demo'/>
          </div>
          <div class="main-box">
            <transition name="page-transition">
              <keep-alive>
                <router-view ref="tab-router" :key="$route.fullPath"/>
              </keep-alive>
            </transition>
          </div>
        </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
  import SideMenu from '../components/Menu/SideMenu'
  import GlobalHeader from '../components/GlobalHeader'
  import {menuCode2RealUrl} from '../api/manage'
  import {triggerWindowResizeEvent} from '../utils/util'
  import {mapGetters} from 'vuex'
  import MultiTab from '../components/MultiTab/MultiTab'
  import events from '../components/MultiTab/events'

  export default {
    name: 'BasicLayout',

    components: {
      GlobalHeader,
      SideMenu,
      MultiTab
    },

    data() {
      return {
        theme: 'light',
        collapsed: false,
        contentWidth: 'Fixed',
        keepAlive: true,
        lastArray: {},
        top: 75
      }
    },

    created() {
      // 添加清楚页签缓存事件
      events.$on('clear', (path, callback) => {
        const vnode = this.$refs['tab-router'].$vnode
        const tab = this.tabs.find(o => o.path === path)
        if (tab) {
          const keep = vnode.parent.componentInstance,
            cache = keep.cache,  // 缓存的组件
            keys = keep.keys  // 缓存的组件名
          if (keys.includes(tab.key)) {
            keys.splice(keys.indexOf(tab.key), 1)
            delete cache[tab.key]
          }
        }
        callback && callback()
      })
    },

    beforeDestroy() {
      events.$off('clear')
    },

    watch: {
      sidebarOpened(val) {
        this.collapsed = !val
      }
    },

    computed: {
      ...mapGetters(['menus', 'tabs','closeObj'])
    },

    methods: {
      demo() {
        // this.closeObj为传过来得对象通过this.$store.dispatch('SetCloseObj', obj)传输
        console.log(this.closeObj);
      },

      toggle() {
        this.collapsed = !this.collapsed
        triggerWindowResizeEvent()
      },

      onSelect({key, data}) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        const path = this.$route.path
        if (data && data.issystem === '1') {
          this.$multiTab.open(data.menuurl, data.menuname,true)
        } else {
          menuCode2RealUrl(key).then(d => {
            this.$multiTab.open(d.result.menuurl, d.result.menuname,true)
            if (d.result.menuurl !== path)
            this.$store.dispatch('SetCurrentMenuCode', key).then(() => {
              this.$router.push(d.result.menuurl)
            })
          })
        }
      }
    }
  }
</script>

<style lang="less">
  @import url('../components/global.less');

  .page-transition-enter {
    opacity: 0;
  }

  .page-transition-leave-active {
    opacity: 0;
  }

  .main-box{
    position: relative;
    overflow-y: auto;
      min-height: 95%;
  }

  .page-transition-enter .page-transition-container,
  .page-transition-leave-active .page-transition-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>
<style>
.layout.ant-layout .ant-layout-sider-children{
    position: fixed;
}
</style>
